import React, { useState } from 'react';
import CorporateInquiry from '../pages/home/CorporateInquiry';

// Filhal ek image import ki hai, baaki jab aayengi tab unke comments hata dena

import imageimage  from '../assets/imageimage.png';
import diwaligift from '../assets/diwaligift.png';
import diwaligiftgift from '../assets/diwaligiftgift.png';
import loveones from '../assets/loveones.png';
import ordernow from '../assets/ordernow.png';
import happy from '../assets/happy.png';

const Hamper = () => {
  const [openFaq, setOpenFaq] = useState(0);

  const stats = [
    { value: '4 lakh+', label: 'hampers delivered' },
    { value: '3,500+', label: 'companies gifted' },
    { value: '75+', label: 'cities across India' },
    { value: '50 to 50,000', label: 'hampers per order' },
  ];

  const steps = [
    { title: 'Sample', desc: 'Order a sampler box or request samples.' },
    { title: 'Customise', desc: 'Pick products, box & branding.' },
    { title: 'Approve', desc: 'Sign off the final hamper & quote.' },
    { title: 'Deliver', desc: 'Multi-city dispatch, timed for Diwali.' },
  ];

  const products = [
    {
      badge: 'NEW',
      name: 'Diwali Special Gift Hamper',
      subtitle: 'Gift Hamper',
      price: 599,
      mrp: 899,
      color: '#F6C9D0',
      image: happy, // Filhal ye image use ho rahi hai
    },
    {
      badge: 'TRENDING',
      name: 'The Perfect Planner Gift Hamper',
      subtitle: 'Plan • Focus • Achieve',
      price: 299,
      mrp: 999,
      color: '#F3D9CF',
      image: imageimage,
    },
    {
      badge: 'BEST SELLER',
      name: 'Bloom Within Luxury Gift Box',
      subtitle: 'Premium Floral Journal & Stationery Gift Set',
      price: 399,
      mrp: 999,
      color: '#1A1A1A',
      image: diwaligift,
    },
    {
      badge: 'NEW',
      name: 'Gift Hamper',
      subtitle: 'Corporate Gift',
      price: 299,
      mrp: 1299,
      color: '#0F0F0F',
      image: diwaligiftgift,
    },
    {
      badge: null,
      name: 'Minimal Journal Gift Set',
      subtitle: 'Luxury Diary Gift Box',
      price: 249,
      mrp: 2999,
      color: '#E7DFCF',
      image: loveones,
    },
    {
      badge: null,
      name: 'Aishcraft Premium Executive Gift Box',
      subtitle: 'Elegant Corporate Gifting for Every Occasion',
      price: 799,
      mrp: 2999,
      color: '#1B2A4A',
      image: ordernow,
    },
  ];

  const faqs = [
    {
      q: 'What is the minimum order quantity for corporate hampers?',
      a: 'We start bulk corporate orders from 50 hampers. For smaller trial or sample orders, you can request under 10 units before committing to a bulk quantity.',
    },
    {
      q: 'Can we add our company logo and branding?',
      a: 'Yes, on orders of 20+ hampers we can add your logo on boxes, gift cards, diaries and packaging as part of our custom branding service.',
    },
    {
      q: 'How long does delivery take?',
      a: 'Standard hampers are dispatched in 3–4 days, while fully customised hampers take 5–7 days. Customisation slots close as Diwali nears, so earlier orders get the most options.',
    },
    {
      q: 'Do you deliver across India?',
      a: 'Yes, we deliver Pan India — to offices, warehouses, and individual employee or client addresses across 75+ cities.',
    },
    {
      q: 'Can we get a sample before placing a bulk order?',
      a: 'Yes, you can request a sampler box first to check quality and packaging before confirming your bulk corporate order.',
    },
    {
      q: 'What payment terms do you offer for bulk orders?',
      a: 'For bulk corporate orders we typically work on an advance plus balance-on-dispatch basis. Our team will share exact terms once your quote is finalised.',
    },
  ];

  return (
    <div className="bg-white text-neutral-900 font-sans overflow-x-hidden pb-24 md:pb-0">

      {/* YELLOW BANNER STRIP */}
      <div className="bg-[#F6DE23] text-center py-3 px-4 sm:py-3.5 sm:px-5">
        <div className="font-serif italic text-base sm:text-lg text-[#6E1423]">
          This Diwali, gift something they'll actually love.
        </div>
        <div className="text-xs sm:text-sm text-neutral-900 mt-1">
          Bulk hampers • Custom branding • Pan India delivery
        </div>
      </div>

      {/* HERO */}
      <section className="pt-6 pb-10 md:pb-14">
        <div className="max-w-6xl mx-auto px-4 sm:px-5 grid grid-cols-1 md:grid-cols-[1.1fr_0.9fr] gap-8 md:gap-10 items-center">
          <div>
            <div className="text-xs sm:text-[13px] font-bold tracking-wide text-[#6E1423] mb-3">
              DIWALI CORPORATE GIFTING · 2026
            </div>
            <h1 className="font-serif text-2xl sm:text-3xl md:text-4xl leading-tight text-neutral-900">
             Diwali hampers from ₹499, and full customisation starts at only ₹299.
            </h1>
            <p className="mt-4 text-sm sm:text-base text-neutral-600 max-w-md">
              Premium diaries, journals and stationery hampers curated for onboarding kits, client thank-yous and festive Diwali gifting.
            </p>
            <div className="flex gap-3 mt-6 flex-wrap">
              <a href="#hp-contact" className="w-full sm:w-auto text-center bg-[#F6DE23] text-neutral-900 font-bold text-sm px-6 py-3.5 rounded">
                Get Bulk Quote
              </a>
              <a href="#hp-products" className="w-full sm:w-auto text-center bg-neutral-900 text-white font-semibold text-sm px-6 py-3.5 rounded">
                See Hampers
              </a>
            </div>
            <div className="flex gap-5 sm:gap-6 mt-8 flex-wrap text-sm text-neutral-600">
              <div><b className="block font-serif text-lg sm:text-xl text-neutral-900">4.8/5</b>500+ reviews</div>
              <div><b className="block font-serif text-lg sm:text-xl text-neutral-900">Growing fast</b>trusted for festive gifting</div>
              <div><b className="block font-serif text-lg sm:text-xl text-neutral-900">50–1000+</b>units per order</div>
            </div>
          </div>

          <div className="bg-[#F6DE23] rounded-lg p-6 sm:p-7">
            <div className="font-serif text-3xl sm:text-4xl text-neutral-900">4.8 / 5</div>
            <div className="text-sm italic mt-3 text-neutral-900">
              "I ordered the corporate hamper for my team and everyone absolutely loved it — 10/10 would recommend."
            </div>
            <div className="text-xs mt-2 text-[#6E1423] font-bold">Verified corporate order</div>
           <div className="grid grid-cols-3 gap-2 mt-5">
  <div className="aspect-square rounded bg-black/15 overflow-hidden">
    <img src={happy} alt="review 1" className="w-full h-full object-cover" />
  </div>
  <div className="aspect-square rounded bg-black/15 overflow-hidden">
    <img src={diwaligift} alt="review 2" className="w-full h-full object-cover" />
  </div>
  <div className="aspect-square rounded bg-black/15 overflow-hidden">
    <img src={loveones} alt="review 3" className="w-full h-full object-cover" />
  </div>
</div>
          </div>
        </div>
      </section>

      {/* STATS STRIP */}
      <section className="bg-[#6E1423] py-10 md:py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-5">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-5">
            {stats.map((s) => (
              <div
                key={s.label}
                className="border border-[#F6DE23]/30 rounded-lg p-5 sm:p-6 text-center bg-[#6E1423]"
              >
                <div className="font-serif text-xl sm:text-2xl md:text-3xl text-[#F6DE23]">
                  {s.value}
                </div>
                <div className="text-xs sm:text-sm text-neutral-200 mt-2">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WHY CHOOSE US */}
      <section className="py-10 md:py-14">
        <div className="max-w-6xl mx-auto px-4 sm:px-5">
          <div className="text-center max-w-xl mx-auto mb-8 md:mb-9">
            <h2 className="font-serif text-2xl sm:text-3xl text-neutral-900">Why teams choose Aishcraft</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5 sm:gap-6">
            <div className="border border-neutral-200 rounded-lg p-5 sm:p-6">
              <h3 className="text-lg font-serif mb-2">Custom branding</h3>
              <p className="text-sm text-neutral-600">Your logo on boxes, cards and diaries — on orders of 20+ hampers.</p>
            </div>
            <div className="border border-neutral-200 rounded-lg p-5 sm:p-6">
              <h3 className="text-lg font-serif mb-2">End-to-end service</h3>
              <p className="text-sm text-neutral-600">Sampling, customisation, packing and dispatch, we handle it all.</p>
            </div>
            <div className="border border-neutral-200 rounded-lg p-5 sm:p-6">
              <h3 className="text-lg font-serif mb-2">Pan India delivery</h3>
              <p className="text-sm text-neutral-600">We ship to offices and homes across the country, on time.</p>
            </div>
          </div>
        </div>
      </section>

      {/* PRODUCTS */}
      <section id="hp-products" className="py-10 md:py-14 bg-[#FFFBEF]">
        <div className="max-w-6xl mx-auto px-4 sm:px-5">
          <div className="text-center max-w-xl mx-auto mb-8 md:mb-9">
            <h2 className="font-serif text-2xl sm:text-3xl text-neutral-900">Popular corporate hampers</h2>
            <p className="mt-2 text-sm sm:text-base text-neutral-600">Every hamper includes a personalised message card and premium gift packaging.</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5 sm:gap-6">
            {products.map((p) => (
              <div key={p.name} className="border border-neutral-200 rounded-lg overflow-hidden bg-white shadow-sm">
                <div className="relative h-48 sm:h-52 bg-neutral-100 overflow-hidden" style={{ background: p.color }}>
                  {p.badge && (
                    <span className="absolute top-3 left-3 z-10 bg-[#F6DE23] text-neutral-900 text-[11px] font-bold px-2.5 py-1 rounded-full shadow">
                      {p.badge}
                    </span>
                  )}
                  <img src={p.image} alt={p.name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-300" />
                </div>
                <div className="p-5">
                  <h3 className="text-base font-serif">{p.name}</h3>
                  <div className="text-sm text-neutral-500 mt-1">{p.subtitle}</div>
                  <div className="mt-3 text-lg font-bold">
                    Rs. {p.price.toLocaleString('en-IN')}{' '}
                    <span className="font-normal line-through opacity-50 text-sm ml-2">
                      Rs. {p.mrp.toLocaleString('en-IN')}
                    </span>
                  </div>
                  <a href="#hp-contact" className="inline-block mt-3 text-sm font-bold border-b-2 border-[#F6DE23]">
                    Enquire →
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="py-10 md:py-14">
        <div className="max-w-6xl mx-auto px-4 sm:px-5">
          <div className="text-center max-w-xl mx-auto mb-9 md:mb-11">
            <h2 className="font-serif text-2xl sm:text-3xl text-neutral-900">How it works</h2>
          </div>

          <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-8 sm:gap-3">
            {steps.map((step, i) => (
              <React.Fragment key={step.title}>
                <div className="flex-1 text-center max-w-[180px] mx-auto sm:mx-0">
                  <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-[#F6DE23] text-[#6E1423] font-serif text-lg flex items-center justify-center mx-auto">
                    {i + 1}
                  </div>
                  <h3 className="font-serif font-bold text-base text-[#6E1423] mt-3">{step.title}</h3>
                  <p className="text-sm text-neutral-600 mt-1">{step.desc}</p>
                </div>
                {i < steps.length - 1 && (
                  <div className="hidden sm:flex items-center justify-center text-neutral-400 pt-5">
                    →
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>

          <div className="mt-9 md:mt-11 max-w-3xl mx-auto border border-[#F6DE23]/50 bg-[#FFFBEF] rounded-lg p-5 sm:p-6 flex items-start gap-3">
            <div className="w-7 h-7 shrink-0 rounded-full bg-[#F6DE23] text-[#6E1423] text-sm flex items-center justify-center mt-0.5">
              🕐
            </div>
            <p className="text-sm text-neutral-700">
              Standard hampers: 3–4 days · Customised: 5–7 days. Customisation slots close as Diwali nears — the earlier you talk to us, the more we can do.
            </p>
          </div>
        </div>
      </section>

      {/* TESTIMONIAL */}
      <section className="py-10 md:py-14">
        <div className="max-w-6xl mx-auto px-4 sm:px-5">
          <div className="bg-[#F6DE23] rounded-lg p-6 sm:p-9 text-center max-w-2xl mx-auto">
            <p className="text-sm sm:text-base italic text-neutral-900">
              "I ordered the corporate hamper for my team and everyone absolutely loved it — 10/10 would recommend."
            </p>
            <div className="mt-4 font-bold text-sm text-[#6E1423]">
              — Verified corporate order, 4.8/5 from 500+ reviews
            </div>
          </div>
        </div>
      </section>

      {/* CONTACT / CORPORATE INQUIRY FORM */}
      <section id="hp-contact" className="py-10 md:py-14">
        <CorporateInquiry />
      </section>

      {/* FAQ */}
      <section className="py-10 md:py-14 bg-[#FFFBEF]">
        <div className="max-w-3xl mx-auto px-4 sm:px-5">
          <div className="text-center max-w-xl mx-auto mb-8 md:mb-9">
            <h2 className="font-serif text-2xl sm:text-3xl text-neutral-900">Questions, answered</h2>
            <p className="mt-2 text-sm sm:text-base text-neutral-600">Everything companies usually ask before placing a bulk Diwali order.</p>
          </div>

          <div className="space-y-3">
            {faqs.map((item, i) => {
              const isOpen = openFaq === i;
              return (
                <div
                  key={item.q}
                  className="border border-neutral-200 rounded-lg bg-white overflow-hidden"
                >
                  <button
                    type="button"
                    onClick={() => setOpenFaq(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 text-left px-5 py-4"
                  >
                    <span className="text-sm sm:text-base font-serif text-neutral-900">
                      {item.q}
                    </span>
                    <span
                      className={`shrink-0 w-6 h-6 rounded-full bg-[#F6DE23] text-[#6E1423] text-sm flex items-center justify-center transition-transform ${
                        isOpen ? 'rotate-45' : ''
                      }`}
                    >
                      +
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-4 text-sm text-neutral-600">
                      {item.a}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="border-t border-neutral-200 py-7 text-center text-sm text-neutral-500 px-4">
        Aishcraft — Personalised Diaries, Planners &amp; Corporate Gift Hampers
      </footer>

      {/* MOBILE BOTTOM BAR */}
      <div className="flex md:hidden fixed left-0 right-0 bottom-0 z-40 bg-white border-t border-neutral-200 p-3 gap-2.5">
        <a
          href="https://wa.me/919406515526?text=Hi%2C%20I%27m%20interested%20in%20corporate%20gift%20hampers"
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 text-center py-3 rounded font-bold text-sm bg-[#25D366] text-white"
        >
          WhatsApp
        </a>
        <a
          href="#hp-contact"
          className="flex-1 text-center py-3 rounded font-bold text-sm bg-[#E53935] text-white"
        >
          Contact
        </a>
      </div>
    </div>
  );
};

export default Hamper;